import React from 'react';
import { AImage } from '../../atoms/AImage/index';
import { MMediaBorder } from '../MMediaBorder';
import * as Styled from './MMediaStack.styles';
import type { MMediaStackProps } from './MMediaStack.types';
import { MMediaStackImageDirection, MMediaStackAspectRatio, MMediaStackImageLayout } from './MMediaStack.types';

const COMPONENT_NAME = 'm-web-ui-kit-MMediaStack';
const TEST_ID = 'web-ui-kit-MMediaStack';

export const MMediaStack: React.FC<MMediaStackProps> = ({
  imageDirection = MMediaStackImageDirection.Diagonal,
  aspectRatio = MMediaStackAspectRatio.TwoThree,
  imageLayout = MMediaStackImageLayout.Default,
  aImage,
  mMediaBorder,
  className,
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
      $imageDirection={imageDirection}
      $aspectRatio={aspectRatio}
      $imageLayout={imageLayout}
      {...rest}
    >
      <Styled.PrimaryMedia $imageDirection={imageDirection} $imageLayout={imageLayout} $aspectRatio={aspectRatio}>
        <AImage {...aImage} />
      </Styled.PrimaryMedia>
      {mMediaBorder && (
        <Styled.SecondaryMedia $imageDirection={imageDirection} $imageLayout={imageLayout} $aspectRatio={aspectRatio}>
          <MMediaBorder {...mMediaBorder} />
        </Styled.SecondaryMedia>
      )}
    </Styled.Wrapper>
  );
};

export * from './MMediaStack.types';
